import React from 'react';
import { Link, Skeleton, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useGetDealRowQuery } from '@/features/deals/dealsApi';
import { paths } from '@/app/routes';

export const DataGridAuditDealName = ({ dealId }) => {
	const { data: dealRow, isLoading } = useGetDealRowQuery(dealId, {
		skip: !dealId,
	});

	if (!dealId) {
		return (
			<Typography variant='body2' color='text.secondary'>
				—
			</Typography>
		);
	}

	if (isLoading) {
		return <Skeleton variant='text' width='8em' />;
	}

	const dealLink = `${paths.deals}/${dealId}`;
	const name = dealRow?.dealName ?? dealId;

	return (
		<Link
			to={dealLink}
			component={RouterLink}
			underline='hover'
			sx={{ textDecorationLine: 'none', width: '100%' }}
		>
			<Typography
				sx={(theme) => ({
					color: theme.palette.primary.main,
					fontWeight: 600,
					'&:hover': {
						textDecoration: 'underline',
					},
				})}
			>
				{name}
			</Typography>
		</Link>
	);
};
